"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ruleStats = exports.orderReport = exports.releaseNote = exports.insightShop = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Get shop-level insight flags (e.g. theme app embed not activated)
*/
const insightShop = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/insightShop`, method: 'get'
    });
};
exports.insightShop = insightShop;
/**
* @summary Get app release notes
*/
const releaseNote = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/releaseNote`, method: 'get'
    });
};
exports.releaseNote = releaseNote;
/**
* @summary Get list of revenue report based on given date the default is last 7 days
*/
const orderReport = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/orderReport`, method: 'get',
        params
    });
};
exports.orderReport = orderReport;
/**
* @summary Get invalid Add-to-Cart attempt / valid order counts per rule-protected product, default is last 7 days
*/
const ruleStats = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/dashboard/ruleStats`, method: 'get',
        params
    });
};
exports.ruleStats = ruleStats;
